import { useQuery } from '@tanstack/react-query';
import { BUBBLE, COMMON, ifyouApi, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
import { IDropListProps } from 'utils/types/common';

export const fetchStoryApi = {
  genreList: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'standard',
        code: 'genre',
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: v.code_name,
          }),
        );
        return newArr;
      })
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  bubbleSetList: () =>
    ifyouApi.get(`${BUBBLE}`).then((res) => {
      const newArr: IDropListProps[] = [];
      res.data?.map((v, i) =>
        newArr.push({
          key: i,
          value: v.set_id,
          text: v.set_name,
        }),
      );
      return newArr;
    }),
  hashTagList: (word) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getHashtagDropdown',
        search_word: word,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.hashtag_no,
            text: v.tag_name,
          }),
        );
        return newArr;
      }),
  exceptionCultureList: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownCulture',
        code: '',
        expression: '',
        project_id: '',
      })
      .then((res) => res.data),
  // live illust 이미지 리스트 - 텍스트로만 출력
  titleCgImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownProjectLiveIllust',
        project_id: projectId,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.live_illust_id,
            text: v.live_illust_name,
          }),
        );
        return newArr;
      }),

  // 작품 수정 - 카테고리 썸네일
  categoryImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'category_thumbnail',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i }))),
  // 작품 수정 - 써클 이미지
  circleImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'ifyou_circle',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i }))),
  // 작품 수정 - 배너 이미지
  bannerImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'ifyou_banner',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i }))),
  // 작품 수정 - 레디 이미지
  readyImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'ifyou_thumbnail',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i }))),
  // 작품 수정 - 종료 이미지
  endingImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'episode_finish',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 작품 수정 - 프리미엄 & 소개 이미지
  premiumImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'premium_pass',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 작품 수정 - 코인샵 배너 이미지
  coinBannerImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'coin_banner',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 작품 수정  - 작품 소개 이미지 / 오토메 작품 수정 - 로고 이미지
  introduceImgList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'introduce_image',
        project_id: projectId,
      })
      .then((res) => res?.data?.map((v, i) => ({ ...v, key: i }))),
};

/// 싱글 프로젝트 드롭다운
export const fetchSingleProjectDropList = () =>
  ifyouApi
    .post(`${COMMON}`, { func: 'getSingleProjectDropdown' })
    .then((res) => res.data);

export const useSingleProjectListQuery = () => {
  const { status, data, error, isFetching } = useQuery(
    ['getSingleProjectDropList'],
    async () => await fetchSingleProjectDropList(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({ key: i, value: v.project_id, text: v.project_name }),
        );
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};

/// 싱글 프로젝트 > 연결 DLC 드롭다운
export const fetchCouponDLCDropList = (projectId) =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'getCouponDlcDropdown',
      project_id: projectId,
    })
    .then((res) => res.data);

export const useCouponDLCListQuery = (projectId = -1) => {
  const { status, data, error, isFetching } = useQuery(
    ['getCouponDLCDropList', projectId],
    async () => await fetchCouponDLCDropList(projectId),
    {
      enabled: !!projectId,
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({ key: i, value: v.dlc_id, text: v.dlc_name }),
        );
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};

/// 싱글 프로젝트 > 연결 재화 드롭다운
export const fetchSingleProjectCouponRewardDropList = (projectId) =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'getSingleProjectCouponRewardDropdown',
      project_id: projectId,
    })
    .then((res) => res.data);

export const useSingleCouponRewardListQuery = (projectId) => {
  const { status, data, error, isFetching } = useQuery(
    ['getSingleCouponRewardDropList', projectId],
    async () => await fetchSingleProjectCouponRewardDropList(projectId),
    {
      enabled: !!projectId,
      select: (data) => {
        const newArr: IDropListProps[] = [];
        data?.map((v, i) =>
          newArr.push({ key: i, value: v.currency, text: v.currency_name }),
        );
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};
